<template>
  <div>
    <BaseTitle :title="$t('menu.schedule')" />
    <v-card class="pa-5 mb-7">
      <h3>{{ $t('filter') }}</h3>
      <v-row>
        <v-col cols="12" md="6">
          <v-select
            v-model="form.classroomId"
            item-value="classroomId"
            :item-text="this.user.cerdasTypeId === 1 ? 'classroomName' : 'name'"
            :items="classroom"
            clearable
            :label="$t('content.classroom')"
            @change="getCourse"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            v-model="form.courseId"
            item-value="courseId"
            clearable
            item-text="name"
            :items="course"
            :label="$t('menu.course')"
            @change="getFilter"
          />
        </v-col>
      </v-row>
    </v-card>

    <div>
      <v-sheet tile height="54" color="#00BF63" class="d-flex" rounded>
        <v-btn icon class="ma-2" @click="prev">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn color="primary" class="btn-primary-custom ma-2" v-if="type === 'day'" @click="back">{{ $t('back') }}</v-btn>
        <v-spacer />
        <div v-if="$refs.calendar" class="pa-4" style="color: #fff">
          {{ $refs.calendar.title }}
        </div>
        <v-spacer />
        <v-btn icon class="ma-2" @click="next">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          :type="type"
          event-overlap-mode="column"
          color="primary"
          v-model="focus"
          :locale="$i18n.locale"
          :events="dataEvent"
          :event-color="getEventColor"
          @change="updateRange"
          @click:event="showEvent"
          @click:more="viewDay"
        ></v-calendar>
        <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
          <v-card color="grey lighten-4" min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-toolbar-title>{{ selectedEvent.course }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-title>{{ selectedEvent.classroom }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <span v-if="selectedEvent.assignment"> {{ $t('menu.assignment') }} : {{ selectedEvent.assignment }} </span>
              <span v-else> {{ $t('content.modules_name') }} : {{ selectedEvent.module }} </span>

              <br />
              <span v-if="selectedEvent.assignmentType"> {{ $t('form.datatype') }} : {{ selectedEvent.assignmentType }} <br /> </span>
              <span v-if="selectedEvent.scheduleType === 'Available From'">{{ $t('information') }} : {{ $t('content.available_from') }}</span>
              <span v-if="selectedEvent.scheduleType === 'Lock'">{{ $t('information') }} : {{ $t('content.lock_schedule') }}</span>
              <!-- <span v-if="selectedEvent.scheduleType === 'Lock'">{{ $t('information') }} : {{ $t('lock') }}</span> -->
              <span v-if="selectedEvent.scheduleType === 'Due Date'">{{ $t('information') }} : {{ $t('content.deadline') }}</span>
              <!-- <span v-else>{{ $t('information') }} : {{ selectedEvent.scheduleType }}</span> -->
              <br />
              <span v-if="(selectedEvent.submittedDate && role === 5) || (selectedEvent.submittedDate && role === 3)">
                {{ $t('content.submitted_date') }} : {{ selectedEvent.submittedDate }} {{ selectedEvent.submittedTime }}
              </span>
              <span v-if="(!selectedEvent.submittedDate && role === 5) || (!selectedEvent.submittedDate && role === 3)"
                >{{ $t('content.submitted_date') }} : {{ $t('content.not_yet_submit') }}</span
              >
            </v-card-text>
            <v-card-actions>
              <v-btn text color="secondary" @click="selectedOpen = false">
                {{ $t('close') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';

export default {
  name: 'Schedule',
  components: {
    BaseTitle
  },

  computed: {
    ...mapGetters({
      role: 'Auth/currentRole',
      student: 'Auth/student',
      user: 'Auth/user'
    }),
    eventStart() {
      if (this.selectedEvent?.start) {
        const date = new Date(this.selectedEvent.start);
        return date.getHours() + ':' + date.getMinutes();
      }
      return null;
    },
    eventEnd() {
      if (this.selectedEvent?.end) {
        const date = new Date(this.selectedEvent.end);
        return date.getHours() + ':' + date.getMinutes();
      }
      return null;
    }
  },
  data: () => ({
    type: 'month',
    focus: '',
    loading: false,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    form: {
      classroomId: null,
      courseId: null
    },
    events: [],
    dataEvent: [],
    classroom: [],
    course: []
  }),
  methods: {
    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    back() {
      this.type = 'month';
    },
    getClassLevel() {
      this.$store
        .dispatch(`Class/${this.user.cerdasTypeId === 1 ? 'fetchListLite' : 'fetchList'}`)
        .then(res => {
          this.classroom = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getClassLevelStudent() {
      this.$store
        .dispatch(`Class/${this.user.cerdasTypeId === 1 ? 'fetchListStudentLite' : 'fetchListStudent'}`)
        .then(res => {
          this.classroom = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getClassLevelParent() {
      this.$store
        .dispatch('Class/fetchListParent', this.student)
        .then(res => {
          this.classroom = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getCourse() {
      if (!this.form.classroomId) {
        this.form.courseId = null;
        if (this.role === 3) {
          this.getDataParent();
        } else if (this.role === 5) {
          this.getDataStudent();
        } else if (this.role === 4) {
          this.getDataTeacher();
        }
        return;
      } else {
        const id = this.role === 3 ? this.student.studentId : this.form.classroomId;
        const payload = { id: id, classid: this.form.classroomId };
        this.$store
          .dispatch('CourseList/fetchList', payload)
          .then(res => {
            this.course = res;
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
      }
    },
    getFilter() {
      if (this.form.courseId) {
        var course = this.form.courseId;
      } else {
        course = '';
      }
      if (this.role === 3) {
        this.$store
          .dispatch('Schedule/fetchListFilterParent', {
            classroomId: this.form.classroomId,
            courseId: course,
            studentId: this.student.studentId
          })
          .then(res => {
            res.forEach(element => {
              const min = new Date(`${element.date}T00:00:00`);
              const max = new Date(`${element.date}T23:59:59`);
              const first = new Date(min.getTime() - (min.getTime() % 900000));
              const last = new Date(max.getTime() - (max.getTime() % 900000));
              element.start = first;
              element.end = last;
              element.name = element.course + ' - ' + element.classroom;
              element.timed = false;
              if (element.scheduleType === 'Available From') {
                element.color = 'blue';
              } else if (element.scheduleType === 'Due Date') {
                element.color = 'red';
              }
            });
            this.dataEvent = res;
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
      } else if (this.role === 5) {
        this.$store
          .dispatch('Schedule/fetchListFilterStudent', { classroomId: this.form.classroomId, courseId: course })
          .then(res => {
            res.forEach(element => {
              const min = new Date(`${element.date}T00:00:00`);
              const max = new Date(`${element.date}T23:59:59`);
              const first = new Date(min.getTime() - (min.getTime() % 900000));
              const last = new Date(max.getTime() - (max.getTime() % 900000));
              element.start = first;
              element.end = last;
              element.name = element.course + ' - ' + element.classroom;
              element.timed = false;
              if (element.scheduleType === 'Available From') {
                element.color = 'blue';
              } else if (element.scheduleType === 'Due Date') {
                element.color = 'red';
              }
            });
            this.dataEvent = res;
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
      } else if (this.role === 4) {
        this.$store
          .dispatch('Schedule/fetchListFilterTeacher', { classroomId: this.form.classroomId, courseId: course })
          .then(res => {
            res.forEach(element => {
              const min = new Date(`${element.date}T00:00:00`);
              const max = new Date(`${element.date}T23:59:59`);
              const first = new Date(min.getTime() - (min.getTime() % 900000));
              const last = new Date(max.getTime() - (max.getTime() % 900000));
              element.start = first;
              element.end = last;
              element.name = element.course + ' - ' + element.classroom;
              element.timed = false;
              if (element.scheduleType === 'Available From') {
                element.color = 'blue';
              } else if (element.scheduleType === 'Due Date') {
                element.color = 'red';
              } else if (element.scheduleType === 'Lock') {
                element.color = 'orange';
              }
            });
            this.dataEvent = res;
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
      }
    },
    getEventColor(event) {
      return event.color;
    },
    getDataStudent() {
      this.$store
        .dispatch('Schedule/fetchListStudent')
        .then(res => {
          res.forEach(element => {
            const min = new Date(`${element.date}T00:00:00`);
            const max = new Date(`${element.date}T23:59:59`);
            const first = new Date(min.getTime() - (min.getTime() % 900000));
            const last = new Date(max.getTime() - (max.getTime() % 900000));
            element.start = first;
            element.end = last;
            element.name = element.course + ' - ' + element.classroom;
            element.timed = false;
            if (element.scheduleType === 'Available From') {
              element.color = 'blue';
            } else if (element.scheduleType === 'Due Date') {
              element.color = 'red';
            } else if (element.scheduleType === 'Lock') {
              element.color = 'orange';
            }
          });
          this.dataEvent = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally((this.loading = false));
    },
    getDataParent() {
      var studentId = this.student.studentId;
      this.$store
        .dispatch('Schedule/fetchListParent', { studentId })
        .then(res => {
          res.forEach(element => {
            const min = new Date(`${element.date}T00:00:00`);
            const max = new Date(`${element.date}T23:59:59`);
            const first = new Date(min.getTime() - (min.getTime() % 900000));
            const last = new Date(max.getTime() - (max.getTime() % 900000));
            element.start = first;
            element.end = last;
            element.name = element.course + ' - ' + element.classroom;
            element.timed = false;
            if (element.scheduleType === 'Available From') {
              element.color = 'blue';
            } else if (element.scheduleType === 'Due Date') {
              element.color = 'red';
            }
          });
          this.dataEvent = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally((this.loading = false));
    },
    getDataTeacher() {
      this.$store
        .dispatch('Schedule/fetchListTeacher')
        .then(res => {
          res.forEach(element => {
            const min = new Date(`${element.date}T00:00:00`);
            const max = new Date(`${element.date}T23:59:59`);
            const first = new Date(min.getTime() - (min.getTime() % 900000));
            const last = new Date(max.getTime() - (max.getTime() % 900000));
            element.start = first;
            element.end = last;
            element.name = element.course + ' - ' + element.classroom;
            element.timed = false;
            if (element.scheduleType === 'Available From') {
              element.color = 'blue';
            } else if (element.scheduleType === 'Due Date') {
              element.color = 'red';
            } else if (element.scheduleType === 'Lock') {
              element.color = 'orange';
            }
            // } else if (element.scheduleType === 'Lock/Unlock') {
            //   element.color = 'green';
            // }
          });
          this.dataEvent = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally((this.loading = false));
    },
    // getData() {
    //   this.$store.dispatch('Schedule/fetchListData').then(res => {
    //     res.data.forEach(element => {
    //       const min = new Date(`${element.date}T00:00:00`);
    //       const max = new Date(`${element.date}T23:59:59`);
    //       const first = new Date(min.getTime() - (min.getTime() % 900000));
    //       const last = new Date(max.getTime() - (max.getTime() % 900000));
    //       element.start = first;
    //       element.end = last;
    //       element.name = element.course + ' - ' + element.classroom;
    //       element.timed = false;
    //       element.color = 'green';
    //     });
    //     this.dataEvent = res.data;
    //   });
    // },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const random = (a, b) => Math.floor((b - a + 1) * Math.random()) + a;

      const events = [];
      const names = ['Biology - IPA X', 'Matematika - IPS X'];
      const colors = ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'];
      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = random(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = random(0, 3) === 0;
        const firstTimestamp = random(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = random(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);
        // console.info(first);

        events.push({
          name: names[random(0, names.length - 1)],
          start: first,
          end: second,
          color: colors[random(0, colors.length - 1)],
          timed: !allDay
        });
      }

      this.events = events;
    }
  },
  created() {
    if (this.role === 3) {
      this.getDataParent();
      this.getClassLevelParent();
    } else if (this.role === 5) {
      this.getDataStudent();
      this.getClassLevelStudent();
    } else if (this.role === 4) {
      this.getDataTeacher();
      this.getClassLevel();
    }
  }
};
</script>
